import { PageHeader } from "../../../components";

export const ImpressumPage: React.FC = () => {
    return (
        <>
            <PageHeader title={"Impressum"}/>
            <div className="uk-container uk-container-large mt-4 mb-4">
                <h2 className="uk-text-primary">
                    Angaben gemäß § 5 TMG:
                </h2>

                <p>
                    Cugate AG <br/>
                    Belziger Str. 72 <br/>
                    10823 Berlin
                </p>

                <h3 className="uk-text-secondary">
                    Vertreten durch:
                </h3>

                <p>
                    Vorstand H. Memo Rhein
                </p>

                <h3 className="uk-text-secondary">
                    Kontakt:
                </h3>

                <p>
                    Telefon: +4903091904390 <br/>
                    Telefax: +4903091904392 <br/>
                    E-Mail: info [=at=] cugate.com
                </p>

                <p>
                    Registergericht: HRB Berlin Charlottenburg <br/>
                    Registernummer: 146486 B
                </p>

                <h3 className="uk-text-secondary">
                    Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:
                </h3>

                <p>
                    DE 143/100/23605
                </p>

                <h2 className="uk-text-primary">
                    Haftungsausschluss (Disclaimer)
                </h2>

                <h3 className="uk-text-secondary">
                    Haftung für Inhalte
                </h3>

                <p>
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
                </p>

                <h3 className="uk-text-secondary">
                    Haftung für Links
                </h3>

                <p>
                    Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
                </p>

                <h3 className="uk-text-secondary">
                    Urheberrecht
                </h3>

                <p>
                    Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
                </p>
            </div>
        </>
    );
};